module.exports = "/fonts/vendor/desiigner-svg/svg/fontawesome/light/bookmark.svg?43e878ffbb22511021f49b6b6b6835e7";